// GB phone-number validation. Mirrors the legacy forms' FormValidation `data-fv-phone___country="GB"`
// rule (same regex), so a number accepted on the legacy journeys is accepted here. The regex handles
// its own spacing/dashes, so the value is only trimmed — not stripped — before testing.
const GB_PHONE = /^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/;

// Empty passes so `nullable`/`required` govern presence separately.
export const isValidGbPhone = (value: unknown): boolean => {
    if (value === null || value === undefined) return true;
    const v = String(value).trim();
    if (v === '') return true;
    if (!GB_PHONE.test(v)) return false;
    // The legacy regex accepts some numbers a digit short, so length-check the national significant
    // number (digits after a leading 0 or +44): UK numbers have 9-10, mobiles (07) exactly 10.
    const national = v.replace(/\D/g, '').replace(/^44/, '').replace(/^0/, '');
    if (national.length < 9) return false;
    if (national.startsWith('7') && national.length !== 10) return false;
    return true;
};
